import './works.css'
import './wwork.css'
import Footer from "./footer"
import RevealTitle from "./RevealTitle"
import ProximityText from "./ProximityText"
import Gallery from "./Gallery"
import { AI_PROJECTS, RepoCard } from "./aiProjects"
import { motion } from "framer-motion"
import { Link } from 'react-router-dom'
import thannu from "../Images/thannu.png"
import pokki from "../Images/pokki.png"
import hume from "../Images/two.png"
import inari from '../Images/one.png'
import upc from "../Images/upc.png"

const cardFade = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] } },
};

function ProjectCard({ to, base, hover, title, desc }) {
    const media = (
        <div className="prjMedia">
            <img src={base} className="prjImg prjImgBase" alt={title} />
            {hover && <img src={hover} className="prjImg prjImgHover" alt={title} />}
            <span className="prjArrow" aria-hidden="true">↗</span>
        </div>
    );
    return (
        <motion.article className="prjCard"
            variants={cardFade} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }}>
            {to ? <Link to={to}>{media}</Link> : media}
            <div className="prjInfo">
                <h3 className="prjTitle">{title}</h3>
                <p className="prjDesc">{desc}</p>
            </div>
        </motion.article>
    );
}

export default function Wwork() {
    return (
        <>
            <section className="section archiveHead">
                <h3 className="sec-label">Work</h3>
                <RevealTitle text="Everything" className="archiveTitle" />
                <motion.p className="archiveStatement"
                    initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.15 }}>
                    <span className="mute">AI systems first</span> — and the design &amp; web craft that led me here.
                </motion.p>
            </section>

            {/* AI — primary */}
            <section className="section archiveProjects">
                <h4 className="workSubhead">AI &amp; Machine Learning</h4>
                <div className="repoGrid">
                    {AI_PROJECTS.map((p) => <RepoCard key={p.title} p={p} />)}
                </div>
            </section>

            {/* Older design/web work — archive */}
            <section className="section archiveProjects">
                <h4 className="workSubhead">Archive · Design &amp; Web</h4>
                <div className="archiveGrid">
                    <ProjectCard to="/prj2" base={inari} hover={hume}
                        title="scholarKart" desc="A scholarship discovery portal for students." />

                    <div className="prjPair">
                        <ProjectCard to="/prj1" base={thannu} hover={pokki}
                            title="CasaVUE" desc="A luxury real-estate concept." />

                        <motion.article className="prjCard"
                            variants={cardFade} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }}>
                            <div className="prjMedia">
                                <img src={upc} className="prjImg prjImgBase" alt="Space Journey" />
                                <span className="prjBadge"><span className="dot" /> Coming soon</span>
                            </div>
                            <div className="prjInfo">
                                <h3 className="prjTitle">Space Journey</h3>
                                <p className="prjDesc">An interactive journey through space.</p>
                            </div>
                        </motion.article>
                    </div>
                </div>
            </section>

            {/* Personal gallery */}
            <section className="section galleryWrap">
                <ProximityText text="Rarely seen with my camera, but when I do, it's bound for this collection." />
            </section>
            <Gallery />

            <Footer />
        </>
    )
}
